import { render, staticRenderFns } from "./popLocationAdd.vue?vue&type=template&id=1463c845&scoped=true&"
import script from "./popLocationAdd.vue?vue&type=script&lang=js&"
export * from "./popLocationAdd.vue?vue&type=script&lang=js&"
import style0 from "./popLocationAdd.vue?vue&type=style&index=0&id=1463c845&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1463c845",
  null
  
)

export default component.exports